import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import PollingFrequencyDataService from "../../services/polling-frequency-data-service/PollingFrequencyDataService";
import { ISpotTagPollingScheduleModel, ITagPollingScheduleUpdateModel } from "../../services/properties-data-service/Models";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type MutationContextType = {
    previous: ISpotTagPollingScheduleModel[];
};

export type UseSaveObjectPollingFrequencyDataParameters = {
    groupID: number,
    eLynxObject: IeLynxObject
} & BaseUseMutationParameters<ISpotTagPollingScheduleModel[], ITagPollingScheduleUpdateModel >;

export function useSaveObjectPollingFrequencyData({
    groupID,
    eLynxObject,
    onError,
    onSuccess
}: UseSaveObjectPollingFrequencyDataParameters) {
    const queryClient = useQueryClient();

    return useMutation<ISpotTagPollingScheduleModel[], RestError, ITagPollingScheduleUpdateModel>(
        (item) => {
            return PollingFrequencyDataService.saveObjectPollingFrequencyData(groupID, eLynxObject, item);
        },
        {
            onMutate: async (item: ITagPollingScheduleUpdateModel) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                // queryClient.refetchQueries({
                //     queryKey: [keys.data],
                //     active: true,
                //     inactive: true
                // });

                return {
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            
        }
    );
}
